"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lang = void 0;
const Lang = {
    MSG_SUCCESS: '成功:',
    MSG_ERROR: '错误: ',
    HELP_MESSAGE: '--h: 帮助信息',
    BUILDIN: {
        CORE_STRTUP: 'code-agent正在启动',
        CORE_STRTUP_DONE: 'code-agent启动完成，通过coda --h 查看所有命令',
        CORE_STRTUP_READY: 'code-agent准备启动，请稍等...',
        CORE_CHECKING_UPDATE: 'code-agent正在检查更新...',
        CORE_LATEST_VERSION: 'code-agent是最新版本.',
        CORE_CHECKING_PACKAGES_VERSION: 'code-agent正在检测依赖包版本...',
        CORE_PACKAGES_LATEST_VERSION: 'code-agent依赖包是最新版本.',
        CORE_PACKAGES_FOUND_NEW_VERSION: 'code-agent依赖包有新版本:',
        CORE_UPDATE_PACKAGES: 'code-agent即将更新依赖包,不要关闭当前命令窗口.',
        CORE_UPDATE_READY: 'code-agent有新版本,即将打开新的命令窗口进行版本升级.',
        CORE_LINUX_INPUT_ROOT_USER_PASSWORD: '注意观察命令行窗口：Linux用户需要输入root密码.',
        CMD_NAME: '输入文件夹名称',
        CMD_DESCRIPTION: '输入命令的描述',
        EXSITED: '已存在',
        NOT_EXSITED: '不存在',
        IS_CREATD_TMPL_FOLDER: '需要创建临时目录',
        IS_RUN_ANNY_PATH: '只能运行在项目根目录',
        CMD_CREATE_SUCCESS: '命令文件创建成功',
        NAME_NO_WHITESPACE: '文件名不能有空格',
        NAME_NO_SPECIAL_CHARACTER: '文件名仅支持"-"或"_"特殊符号',
        NAME_LOWERCASE: '文件名必须小写',
        ADD_CMD_CONFIG: '添加到配置命令文件',
        ADD_CMD_CONFIG_SUCCESS: '添加到配置命令文件成功',
        ADD_CMD_EXTENSIONS: '添加到扩展命令',
        ADD_CMD_EXTENSIONS_SUCCESS: '添加到扩展命令成功',
        ADD_CMD_PACKAGE: '添加到package.json',
        ADD_CMD_PACKAGE_SUCCESS: '添加到package.json成功',
        NO_COMMAND: '没有该名称的命令',
        MEAN_SUCH: '你的意思是:',
        COMMAND_LENGTH_TOO_LONG: '命令单词长度太长',
        NO_THIS_FOLDER: '没有找到该名称的目录',
        DELETE_COMMAND_TIPS: '即将删除命令文件',
        DELETE_COMMAND_SUCCESS: '删除命令文件成功',
        DELETE_COMMAND_FLOW_SUCCESS: '删除命令流程已结束',
        CLI_HAS_READY: 'code-agent准备就绪，即将执行命令',
        CLI_VOLIDATING_CMD: 'code-agent校验命令',
        CLI_VOLIDATE_CMD_SUCCESS: 'code-agent校验命令成功',
    },
    EXTENSION: {
        CHOICE_PROJECT_TYPE: '选择项目类型',
        CHOICE_PROJECT_STACK: '选择项目技术栈',
        SUPORT_LATER: '暂不支持',
        PROJECT_NAME: '输入项目名称',
        PROJECT_WILL_CREATE: '项目文件即将被创建',
        PROJECT_CREATE_SUCCESS: '项目我呢见创建成功',
        PROJECT_INSTALL_TIPS: '项目即将安装依赖包,不要关闭当前命令窗口',
        PROJECT_CREATE_FLOW_DONE: '创建项目流程结束',
        CREATE_PKG_DONE: '创建项目package.json结束',
        CREATE_WEBPACK_DONE: '创建项目webpack相关配置结束',
        CREATE_PROJECT_DONE: '创建项目文件结束',
        PROJECT_FOLDER_PATH: '项目目录在',
        TMPL_NOT_EXSITED: '模板文件不存在',
        PROJECT_SUBAPP_NAME: '输入子应用的名称',
        PROJECT_DEV_SERVER: '选择打包工具',
        COPY_PLAYER_CODE: '是否复制视频播放器代码到项目',
        COPY_PLAYER_CODE_PATH: '输入相对路径',
        INSTALL_PLAYER_PACKAGE: '正在安装视频播放器依赖包',
        COPY_PLAYER_CODE_START: '开始复制视频播放器代码',
        COPY_PLAYER_CODE_SUCCESS: '复制视频播放器代码成功',
        ADD_PLAYER_FLOW_DONE: '添加视频播放器流程结束',
        NOT_EXSITED_PKGJSON: '在当前根目录不存在package.json',
        FFMPEG_NOT_SUPPORT_WIN: '仅支持Ubuntu系统',
    },
};
exports.Lang = Lang;
